import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ProductType_Enum } from "../types";
import { getAccountId } from "../utils";
import { useCurrentAccount } from "./useCurrentAccount";
export var useProtectUnpublishedProduct = function(data) {
    var navigate = useNavigate();
    useEffect(function() {
        if (!data) return;
        var isLive = data.isLive, isPublic = data.isPublic, owner = data.owner, type = data.type;
        var isAccessible = isPublic || type === ProductType_Enum.Unlisted;
        if (!(isLive && isAccessible) && owner !== getAccountId()) {
            navigate("/");
        }
    }, [
        data,
        navigate
    ]);
};
export var useProtectManageProduct = function(data) {
    var canCreateProducts = useCurrentAccount().canCreateProducts;
    var navigate = useNavigate();
    useEffect(function() {
        if (!data) return;
        // Wait until permissions have resolved before evaluating access.
        // When null, the fetch is still in-flight; acting on it would either
        // flash protected content (if we allow) or incorrectly redirect (if we deny).
        if (canCreateProducts === null) return;
        var owner = data.owner;
        if (canCreateProducts === false || owner !== getAccountId()) {
            navigate("/");
        }
    }, [
        data,
        canCreateProducts,
        navigate
    ]);
    return {
        isLoading: canCreateProducts === null
    };
};

//# sourceMappingURL=useProtectPage.js.map